import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const ToolbarPageCounter = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(props.currentPage);

  const handlePageChange = e => {
    const newPage = parseInt(e.target.value);
    if (newPage > 0 && newPage <= props.totalPages && !isNaN(newPage)) {
      props.goToPage(newPage);
      setPage(newPage);
    } else {
      setPage(e.target.value);
    }
  };

  const selectText = e => {
    // setSelectionRange is used here to support mobile
    e.target.setSelectionRange(0, e.target.value.length);
  };

  const handleBlur = () => setPage(props.currentPage);

  const ariaLabel = t('Toolbar.Input.Page', {
    defaultValue: `Page ${props.currentPage}`,
    replace: { page: page === '' ? '' : props.currentPage }
  });

  return (
    <div className="up-toolbar-page-counter">
      <input
        type="text"
        datatest="currentPageInput"
        className="up-current-page-input"
        onBlur={handleBlur}
        onChange={handlePageChange}
        onClick={selectText}
        onFocus={selectText}
        ref={ref}
        style={{
          // These styles are here to ensure the input box expands
          // depending on the number of digits
          boxSizing: 'content-box',
          width: `${String(props.currentPage).length * 8}px`
        }}
        tabIndex={props.tabIndex}
        value={page === '' ? '' : props.currentPage}
        aria-label={ariaLabel}
      />
      <span className="up-page-counter-spacer">/</span>
      <span>{props.totalPages}</span>
    </div>
  );
});

export default ToolbarPageCounter;
